var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36.934,
    height: 34.466,
    viewBox: "0 0 36.934 34.466",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_294",
    "data-name": "Rectangle 294",
    width: 36.934,
    height: 34.466,
    fill: "#98d39f"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_388",
    "data-name": "Groupe 388",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_348",
    "data-name": "Groupe 348",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2836",
    "data-name": "Trac\\xE9 2836",
    d: "M53.858,41.108a1.275,1.275,0,0,1-1.139,1.211,4.405,4.405,0,0,1-.567.029q-4.91,0-9.827,0t-9.826,0a4.293,4.293,0,0,1-.608-.034,1.267,1.267,0,0,1-1.107-1.32,1.3,1.3,0,0,1,1.229-1.177c.122-.008.243-.008.369-.008H45.012q3.679,0,7.369,0a1.585,1.585,0,0,1,1.116.39,1.185,1.185,0,0,1,.361.9",
    transform: "translate(-16.925 -23.132)",
    fill: "#98d39f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2837",
    "data-name": "Trac\\xE9 2837",
    d: "M53.854,70.9a1.3,1.3,0,0,1-1.242,1.215c-.09.008-.185.008-.28.008H32.282a1.656,1.656,0,0,1-1.152-.4,1.184,1.184,0,0,1-.356-.909,1.261,1.261,0,0,1,1.1-1.194,3.722,3.722,0,0,1,.612-.034q9.825-.006,19.649,0a4.525,4.525,0,0,1,.567.025,1.265,1.265,0,0,1,1.148,1.29",
    transform: "translate(-16.921 -40.431)",
    fill: "#98d39f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2838",
    "data-name": "Trac\\xE9 2838",
    d: "M53.85,11.352a1.3,1.3,0,0,1-1.265,1.19,2.186,2.186,0,0,1-.234.008H32.3a1.379,1.379,0,0,1-1.513-1.127A1.258,1.258,0,0,1,31.9,10.033a3,3,0,0,1,.54-.034h19.73a3.422,3.422,0,0,1,.527.025,1.28,1.28,0,0,1,1.153,1.328",
    transform: "translate(-16.922 -5.81)",
    fill: "#98d39f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2839",
    "data-name": "Trac\\xE9 2839",
    d: "M13.183,31.008a1.432,1.432,0,0,1-.514,1.047c-1.238,1.169-2.484,2.333-3.727,3.5L6.885,37.481c-.464.436-.923.867-1.386,1.3a1.591,1.591,0,0,1-1.076.494,1.584,1.584,0,0,1-1.067-.49c-.95-.871-1.891-1.751-2.832-2.631A1.271,1.271,0,0,1,.133,34.59a1.378,1.378,0,0,1,.99-.716,1.431,1.431,0,0,1,1.184.377c.472.423.931.855,1.391,1.286l.671.624L9.9,31.012c.275-.256.545-.511.824-.762a1.412,1.412,0,0,1,2.021-.117,1.2,1.2,0,0,1,.442.876",
    transform: "translate(0 -17.293)",
    fill: "#98d39f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2840",
    "data-name": "Trac\\xE9 2840",
    d: "M13.148,61.069a1.663,1.663,0,0,1-.45.8c-2.13,2-4.443,4.16-7.279,6.783a1.445,1.445,0,0,1-.986.427,1.486,1.486,0,0,1-1-.432c-.91-.838-1.81-1.68-2.71-2.522l-.238-.218a1.2,1.2,0,0,1-.4-1.366,1.315,1.315,0,0,1,.95-.855,1.424,1.424,0,0,1,1.264.352c.482.432.959.876,1.418,1.311l.454.427c.068.063.131.13.212.218a1.618,1.618,0,0,1,.18-.205q3.1-2.891,6.2-5.773a1.386,1.386,0,0,1,1.6-.314,1.288,1.288,0,0,1,.784,1.366",
    transform: "translate(-0.001 -34.614)",
    fill: "#98d39f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2841",
    "data-name": "Trac\\xE9 2841",
    d: "M13.18,1.239a1.326,1.326,0,0,1-.455.985c-.8.762-1.6,1.517-2.408,2.266L7.994,6.673c-.81.762-1.62,1.521-2.435,2.283A1.668,1.668,0,0,1,4.433,9.5h0A1.672,1.672,0,0,1,3.3,8.96l-.554-.515C2,7.75,1.246,7.054.5,6.355A1.2,1.2,0,0,1,.292,4.6a1.316,1.316,0,0,1,.936-.519,1.456,1.456,0,0,1,1.08.394c.459.411.909.834,1.359,1.253.207.2.418.394.63.591a.969.969,0,0,0,.077.067L10.1,1.055c.225-.209.45-.423.68-.628A1.425,1.425,0,0,1,12.743.36a1.2,1.2,0,0,1,.437.88",
    transform: "translate(-0.002 0)",
    fill: "#98d39f"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListIcon2);
export default __webpack_public_path__ + "static/media/list-icon-2.6566b289785ed4377a34239badc29707.svg";
export { ForwardRef as ReactComponent };